<template>
    <Modal :open="open" :show-close-icon="true" @close="closeModal" :is-card="true" :narrow="true" :close-has-background="true" :vertical-content="true">
        <template slot="body">
            <h2>Unable to retrieve registration details</h2>
            <p>We were unable to retrieve details of this vehicle. Please ensure you have entered the registration number correctly.</p>
            <p>Registration: {{ this.registration }}</p>
            <p>If correct, please click continue to fill out the form which will be sent to your nearest dealership. Otherwise please press back and adjust your registration.</p>
        </template>
    </Modal>
</template>

<script>
import Modal from '../../../core/components/Modal.vue';
import { mapState } from 'vuex';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        closeModal() {
            this.open = false;
        },
    },
    computed: {
        ...mapState('ValuationTool', ['hasUkVehicleData', "registration", "otherSelected"]),
    },
    mounted() {
        if(!this.hasUkVehicleData && this.otherSelected === false ){
            this.open = true;
        }
    },
}

</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/VehicleNotFoundModal.vue